import React from 'react';

const ClockFilledIcon = () => {
	return (
		<svg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path d='M10.0001 2.16797C5.41675 2.16797 1.66675 5.91797 1.66675 10.5013C1.66675 15.0846 5.41675 18.8346 10.0001 18.8346C14.5834 18.8346 18.3334 15.0846 18.3334 10.5013C18.3334 5.91797 14.5834 2.16797 10.0001 2.16797ZM13.5001 13.418C13.2501 13.7513 12.7501 13.8346 12.4167 13.5846C12.4167 13.5846 10.4167 12.168 9.50008 11.5013C9.30946 11.3627 9.16675 11.168 9.16675 10.918C9.16675 9.91797 9.16675 7.7513 9.16675 6.7513C9.16675 6.33464 9.50008 6.0013 9.91675 6.0013C10.3334 6.0013 10.6667 6.33464 10.6667 6.7513C10.6667 7.66797 10.6667 10.5013 10.6667 10.5013L13.2501 12.3346C13.6667 12.668 13.7501 13.0846 13.5001 13.418Z' />
		</svg>
	);
};

export default ClockFilledIcon;
